import SalesforceActivation from '@/app/community-salesforce-integration/pages/SalesforceActivation.vue';
import SalesforceActivationComplete from '@/app/community-salesforce-integration/pages/SalesforceActivationComplete.vue';
import SalesforceEmbed from '@/app/community-salesforce-integration/pages/SalesforceEmbed.vue';
import SalesforceError from '@/app/community-salesforce-integration/pages/SalesforceError.vue';

const App = () => import('@/app/community-salesforce-integration/App.vue');

const PAGE_LEVEL_TOP = 'Community Salesforce Integration';

export default {
  path: '',
  component: App,
  meta: {
    hideNav: true,
    hidePrimaryNav: true,
    isSalesforceEmbed: true,
  },
  children: [
    {
      name: 'community-salesforce-integration',
      path: 'community-salesforce-integration/:caseId',
      component: SalesforceEmbed,
      meta: {
        analytics: `${PAGE_LEVEL_TOP}`,
        requiresAuth: true,
      },
    },
    {
      name: 'community-salesforce-integration-activation',
      path: 'community-salesforce-authorization',
      component: SalesforceActivation,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Activation`,
        requiresAuth: false,
      },
    },
    {
      name: 'community-salesforce-integration-activation-callback',
      path: 'community-salesforce-authorization-complete',
      component: SalesforceActivationComplete,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Activation Complete`,
        requiresAuth: false,
      },
    },
    {
      name: 'community-salesforce-integration-error',
      path: 'community-salesforce-integration-error',
      component: SalesforceError,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Connection Error`,
        requiresAuth: false,
      },
    },
  ],
};
